import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function RCRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, body, params } = getRequestProps(ConnectionNames.realityCheck, message);
    if (typeof params !== "undefined") {
        headers["Content-Type"] = "application/json; charset=utf-8";
        body = JSON.stringify(params);
    }
    return new Request(`${baseUrl}${endpoint}`, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=RCRequestFormatter.js.map